import { Participant, ZoomClient } from '@/Types/zoom';
import { useCallback, useEffect, useRef } from 'react';
import { useMount } from '../../../hooks';
import { miniScreenUserIdVar } from '../meetingVar';
export function useParticipantsChange(
  zmClient: ZoomClient,
  fn: (participants: Participant[], updatedParticipants?: Participant[]) => void,
) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const callback = useCallback(
    (updatedParticipants?: Participant[]) => {
      const participants = zmClient.getAllUser();
      fnRef.current?.(participants, updatedParticipants);
      miniScreenUserIdVar(zmClient?.getCurrentUserInfo()?.userId);
    },
    [zmClient],
  );
  useEffect(() => {
    zmClient.on('user-added', callback);
    zmClient.on('user-removed', callback);
    zmClient.on('user-updated', callback);
    return () => {
      zmClient.off('user-added', callback);
      zmClient.off('user-removed', callback);
      zmClient.off('user-updated', callback);
    };
  }, [zmClient, callback]);
  useMount(() => {
    callback();
  });
}
